import { AppSettings } from '@app-types';
import axios from './axios';

const fetchAppSettings = () => axios.get<AppSettings>('/app-settings');

export default { fetchAppSettings };